import { htmlTag } from './htmlTag.function.js';
export { htmlTag };
export { noElement } from './noElement.function.js';
export { elementVarToHtmlString } from './elementVarToHtmlString.function.js';
export const button = htmlTag('button');
export const select = htmlTag('select');
export const option = htmlTag('option');
export const optgroup = htmlTag('optgroup');
export const input = htmlTag('input');
export const textarea = htmlTag('textarea');
// HEAD & SUPPORT ELEMENTS
export const html = htmlTag('html'); // TODO: get this named to html
export const head = htmlTag('head');
export const title = htmlTag('title');
export const meta = htmlTag('meta');
export const link = htmlTag('link');
export const style = htmlTag('style');
export const body = htmlTag('body');
export const script = htmlTag('script');
export const noscript = htmlTag('noscript');
// BLOCK ELEMENTS
export const hr = htmlTag('hr');
export const h1 = htmlTag('h1');
export const h2 = htmlTag('h2');
export const h3 = htmlTag('h3');
export const h4 = htmlTag('h4');
export const h5 = htmlTag('h5');
export const h6 = htmlTag('h6');
export const ol = htmlTag('ol');
export const ul = htmlTag('ul');
export const li = htmlTag('li');
export const div = htmlTag('div');
export const main = htmlTag('main');
export const section = htmlTag('section');
export const header = htmlTag('header');
export const footer = htmlTag('footer');
export const form = htmlTag('form');
export const fieldset = htmlTag('fieldset');
export const legend = htmlTag('legend');
export const dialog = htmlTag('dialog');
export const pre = htmlTag('pre');
// TABLE ELEMENTS
export const table = htmlTag('table');
export const tr = htmlTag('tr');
export const td = htmlTag('td');
export const th = htmlTag('th');
export const thead = htmlTag('thead');
export const tbody = htmlTag('tbody');
export const tfoot = htmlTag('tfoot');
export const iframe = htmlTag('iframe');
// INLINE ELEMENTS
export const a = htmlTag('a');
export const u = htmlTag('u');
export const img = htmlTag('img');
export const br = htmlTag('br');
export const label = htmlTag('label');
export const p = htmlTag('p');
export const small = htmlTag('small');
export const span = htmlTag('span');
export const strong = htmlTag('strong');
export const b = htmlTag('b');
export const sup = htmlTag('sup');
export const nav = htmlTag("nav");
export const figure = htmlTag("figure");
export const figcaption = htmlTag("figcaption");
export const code = htmlTag("code");
// OTHER
export const canvas = htmlTag('canvas');
export const svg = htmlTag('svg');
export const path = htmlTag('path');
export const polygon = htmlTag('polygon');
export const rect = htmlTag('rect');
export const details = htmlTag('details');
export const summary = htmlTag('summary');
